import styled from "styled-components";
// import { Scrollable, panelSpacing } from "../../../../../common/styles";
// import colors from "../../../../../config/colors";

/***************** */
export const SubscriptionContainer = styled.div``;
export const SubscriptionHead = styled.div``;
export const SubscriptionHeading = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  max-width: 95%;
  margin: 0 auto;
`;
